export default __webpack_public_path__ + "1b5078d77e8a45dcd865f176bc1b2937.svg";